import React, { Component } from 'react'
import { Form, Input, Button, Card, InputNumber } from 'antd'
import PaymentForm from './components/PaymentForm'
import PaymentInformationComponent from './components/PaymentInformationComponent'
import Optional from 'components/LayoutComponents/Optional'

import { connect } from 'react-redux'
import { initializePayment } from '../actions'

const mapStateToProps = state => {
  return {
    loading: state.paymentSimulator.loading,
    paymentData: state.paymentSimulator.paymentData,
    showPaymentInformation: state.paymentSimulator.showPaymentInformation,
  }
}
@Form.create()
@connect(
  mapStateToProps,
  { initializePayment },
)
class PaymentSimulationApp extends Component {
  onSubmit = isSubmitForm => event => {
    event.preventDefault()
    const { form } = this.props

    if (!isSubmitForm) {
      form.validateFields((error, values) => {
        if (!error) {
          this.props.initializePayment(values)
        }
      })
    }
  }

  hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field])
  }

  render() {
    return (
      <Card>
        <Optional visible={!this.props.showPaymentInformation}>
          <PaymentForm
            hasErrors={this.hasErrors}
            onSubmit={this.onSubmit}
            loading={this.props.loading}
            form={this.props.form}
          />
        </Optional>

        <Optional visible={this.props.showPaymentInformation}>
          <PaymentInformationComponent expires={10} />
        </Optional>
      </Card>
    )
  }
}

export default PaymentSimulationApp



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/PaymentSimulationApp/index.js